import { Bars, Times } from '@assets/svgs';
import { Box, Grid, Zoom } from '@mui/material';
import { IconButton } from '@components/iconButton';
import { DrawerList } from '@pages/QuoteDetails/constants/DrawerList.enum';
import { useLayoutStore } from '@store/LayoutStore';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { shallow } from 'zustand/shallow';

export const MobileHeaderButton = () => {
  const [secondaryMenuTab, showHeaderMenu, openHeaderMenu, closeHeaderMenu, setSecondaryMenuTab] = useLayoutStore(
    (state) => [
      state.secondaryMenuTab,
      state.showHeaderMenu,
      state.openHeaderMenu,
      state.closeHeaderMenu,
      state.setSecondaryMenuTab,
    ],
    shallow,
  );
  const [searchParams, setSearchParams] = useSearchParams();

  const hamburger = (
    <Box>
      <Bars />
    </Box>
  );
  const times = (
    <Box
      sx={{
        color: 'common.white',
      }}
    >
      <Times color='common.white' height='20px' />
    </Box>
  );

  useEffect(() => {
    if (!secondaryMenuTab) {
      setSecondaryMenuTab(DrawerList.Navigator);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryMenuTab]);

  const handleCloseMenu = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('sidebarItem');
    setSearchParams(newParams, { replace: true });
    closeHeaderMenu();
  };

  return (
    <Grid
      sx={{
        width: '80px',
      }}
    >
      {!showHeaderMenu && (
        <IconButton onClick={openHeaderMenu}>
          <Zoom in={!showHeaderMenu}>{hamburger}</Zoom>
        </IconButton>
      )}
      {showHeaderMenu && (
        <IconButton onClick={handleCloseMenu}>
          <Zoom in={showHeaderMenu}>{times}</Zoom>
        </IconButton>
      )}
    </Grid>
  );
};
